export default __webpack_public_path__ + "static/media/undeadminionmutilator.976d273a.png";